import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { RequestDutiesRefundCTA } from "./ctas";
export var RequestDutiesReimbursementIA = function RequestDutiesReimbursementIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize, articles) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return RequestDutiesRefundCTA(strictLocalize, articles);
  }
  if (!orderIsFreeDutiesEligible(brandOrder)) {
    return undefined;
  }
  return RequestDutiesRefundCTA(strictLocalize, articles);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED(strictLocalize), YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED(strictLocalize), EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize)];
    }
  };
};
var DUTIES_REIMBURSEMENT = function DUTIES_REIMBURSEMENT(strictLocalize) {
  return strictLocalize({
    id: "YISJZw",
    defaultMessage: [{
      "type": 0,
      "value": "Vergoeding van invoerrechten"
    }]
  });
};
var WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED = function WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED(strictLocalize) {
  return strictLocalize({
    id: "j06O25",
    defaultMessage: [{
      "type": 0,
      "value": "Als invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van invoerrechten voor je bestelling weerspiegelt. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw), die je volledig betaalt. Als de werkelijke kosten van invoerrechten en uitbetalingsvergoeding hoger uitvallen dan de promotie die je hebt ontvangen, kun je het verschil terugvragen in Faire-tegoed wanneer de bestelling is geleverd."
    }]
  });
};
var YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED = function YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED(strictLocalize) {
  return strictLocalize({
    id: "8rOH2d",
    defaultMessage: [{
      "type": 0,
      "value": "Als de invoerrechten voor je bestelling niet worden gedekt, betaal je rechtstreeks en volledig aan de vervoerder en kun je geen terugbetaling van de invoerrechten aanvragen."
    }]
  });
};
var EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST = function EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize) {
  return strictLocalize({
    id: "1ckXmV",
    defaultMessage: [{
      "type": 0,
      "value": "Btw, accijnzen en andere kosten worden niet gedekt door Faire, dus laat deze kosten buiten beschouwing bij de aanvraag van een terugbetaling."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "DH6hjb",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling komt in aanmerking voor de promotie met gratis invoerrechten. Als invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van invoerrechten voor je bestelling weerspiegelt. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw), die je volledig betaalt. Als de werkelijke kosten van invoerrechten en uitbetalingsvergoeding hoger uitvallen dan de promotie die je hebt ontvangen, kun je het verschil terugvragen in Faire-tegoed wanneer de bestelling is geleverd."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "lmtMK2",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling komt niet in aanmerking voor de promotie met gratis invoerrechten en daarom kun je geen terugbetaling van invoerrechten aanvragen. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw), die je volledig betaalt. "
    }]
  });
};